const STORAGE_KEY = 'wiki_recent';
const MAX_ITEMS = 15;

export function getWikiRecent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(arr)) return [];
    return arr
      .filter((item) => item && typeof item.slug === 'string' && item.slug.trim())
      .slice(0, MAX_ITEMS);
  } catch (_) {
    return [];
  }
}

export function addWikiRecent(slug, title) {
  const slugStr = String(slug || '').trim();
  if (!slugStr) return;
  const list = getWikiRecent();
  const viewedAt = Date.now();
  const rest = list.filter((item) => item.slug !== slugStr);
  const updated = [{ slug: slugStr, title: title != null ? String(title) : undefined, viewedAt }, ...rest].slice(
    0,
    MAX_ITEMS
  );
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
}
